import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import 'babel-polyfill' // ie8-11
import store from '@/store'
import router from '@/router'
import { trackApiRequest } from './userTrack'

// axios.defaults.baseURL = 'https://www.gaosiedu.com/restapi';

const instance1 = axios.create({
    baseURL: 'https://api.gaosiedu.com/util',
  });
// axios.defaults.baseURL = 'https://test.gaosiedu.com/restapi';
// axios.defaults.baseURL = 'https://test.gsviponline.com/restapi';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default function request(option, success, fail) {
    // 登录支付不显示
    if (router.history.current.name != 'payWeixin') {
        Vue.prototype.$loading('数据加载中')
    }
    const trackParams = option.type == 'get' ? Object.assign({}, option.query || {}) : (option.data || {});
    let url;
    if (option.query) {
        option.query = sortQuery(option.query);
    }

    if (option.query == '') {
        url = option.api;
    } else {
        url = option.api + '?' + option.query;
    }

    if (option.type == 'post') {
        option.data = option.data;
    }

    option.query = option.query;

    url = option.defaultUrl ? option.defaultUrl + url : url //defaultUrl为Mock数据接口
    trackApiRequest({
        url,
        method: option.type,
        params: trackParams,
        extra: {
            baseURL: 'https://api.gaosiedu.com/util'
        }
    });
    instance1({
        url: url,
        method: option.type,
        data: option.data || {},
        headers: {
            'GS-Token': store.state.user.stu_token || '',
            'Accept': option.Accept ? option.Accept : 'application/vnd.gsapi.v1+json',
            'Access-Control-Allow-Origin': '*'
        }
    }).then(function(res) {
        // 微信支付不显示
        if (router.history.current.name != 'payWeixin') {
            Vue.prototype.$loading.close()
        }
        var res = res.data;
        if (res.code == 0) {
            success(res)
            console.log(res)
        } else if (res.code == 1001 || res.code == 1009) {
            Vue.prototype.$toast.center('未登录，请先登录');
            //router.push('/loginCode')
            localStorage.removeItem('user');
            router.replace({
                path: "/loginCode",
                query: {
                    redirect: router.currentRoute.fullPath
                }
            })
        } else if (res.code == 1005) {
            Vue.prototype.$toast.center('网络故障')
        } else if (res.code == 1007) {
            Vue.prototype.$toast.center('微信用户openid或者学员信息获取失败')
        } else if (res.code == 1008) {
            Vue.prototype.$toast.center('登录过期')
            router.push('/loginCode')
        } else if (res.code == 1010) {
            Vue.prototype.$toast.center('图形验证码输入错误')
        } else if (res.code == 429) {
            Vue.prototype.$toast.center('请求过于频繁，请稍候再试')
        } else if (res.code == 10002) {
            Vue.prototype.$toast.center('用户信息未完善')
            router.push('/p-Data')
        } else {
            if (fail != null) {
                fail(res)
            } else {
                Vue.prototype.$toast.center(res.Message)
            }

        }
    }).catch((err) => {
        Vue.prototype.$loading.close()
            // if(err.response.status == 429){
            //   Vue.prototype.$toast.center('请求过于频繁，请稍候再试')
            // }else {
            //   alert(err)
            // }
    })
};

function sortQuery(obj) {
    // 先获取所有属性名
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    // 排序
    keys.sort();
    // 导出新的对象
    var r = {};
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        r[key] = obj[key];
    }
    // 将排序好的对象转为请求参数
    var str = '';
    for (var k in r) {
        str += k + '=' + r[k] + '&'
    }
    return str.substr(0, str.length - 1);
};



//////////////////
// WEBPACK FOOTER
// /resource/code/pmn3myn9-dev_guanwang_1.5.422/packages/gaosiweb-common/js/request.js
// module id = /k1z
// module chunks = 72